import { useTranslation } from 'react-i18next';
import type { CommandeStatus, DevisStatus } from '@erp/domain/pro';

const DEVIS_CLASS: Record<DevisStatus, string> = {
  en_attente: 'pro-status-pending',
  valide: 'pro-status-validated',
  rejetee: 'pro-status-rejected',
};

const COMMANDE_CLASS: Record<CommandeStatus, string> = {
  en_attente: 'pro-status-pending',
  confirmee: 'pro-status-confirmed',
  emballee: 'pro-status-packed',
  expediee: 'pro-status-shipped',
  livree: 'pro-status-delivered',
  retournee: 'pro-status-returned',
  rejetee: 'pro-status-rejected',
};

const DEVIS_LABELS: Record<DevisStatus, string> = {
  en_attente: 'En attente',
  valide: 'Validé',
  rejetee: 'Rejetée',
};

const COMMANDE_LABELS: Record<CommandeStatus, string> = {
  en_attente: 'En attente',
  confirmee: 'Confirmée',
  emballee: 'Emballée',
  expediee: 'Expédié',
  livree: 'Livrée',
  retournee: 'Retournée',
  rejetee: 'Rejetée',
};

export function DevisStatusBadge({ status }: { status: DevisStatus }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium ${DEVIS_CLASS[status]}`}
    >
      {t(`pro.devis.status.${status}`, DEVIS_LABELS[status])}
    </span>
  );
}

export function CommandeStatusBadge({ status }: { status: CommandeStatus }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium ${COMMANDE_CLASS[status]}`}
    >
      {t(`pro.commande.status.${status}`, COMMANDE_LABELS[status])}
    </span>
  );
}
